import { render, staticRenderFns } from "./FraudOrders.vue?vue&type=template&id=87beedbc&"
import script from "./FraudOrders.vue?vue&type=script&lang=js&"
export * from "./FraudOrders.vue?vue&type=script&lang=js&"
import style0 from "./FraudOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports